import { render, staticRenderFns } from "./investment_index.vue?vue&type=template&id=7f7af257&scoped=true"
import script from "./investment_index.vue?vue&type=script&lang=js"
export * from "./investment_index.vue?vue&type=script&lang=js"
import style0 from "./investment_index.vue?vue&type=style&index=0&id=7f7af257&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7af257",
  null
  
)

export default component.exports